import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { AsciiEffect } from "three/examples/jsm/effects/AsciiEffect.js";
import { TrackballControls } from "three/examples/jsm/controls/TrackballControls.js";

if (typeof window !== "undefined") {
  window.THREE = THREE;
}
const three = {
  ...THREE,
  GLTFLoader: GLTFLoader,
  DRACOLoader: DRACOLoader,
  OrbitControls: OrbitControls,
  AsciiEffect: AsciiEffect,
  TrackballControls: TrackballControls,
};

export default three;
